const productUrl = 'https://sklm.ai.1andx.com'
//陈工新接口
const apiUrlNew='https://sklm.ai.1andx.com/api3'
module.exports = {
    urls: process.env.NODE_ENV === 'development' ? '/BASE_URL' : productUrl,
	//陈工新接口
	apiUrlNew:apiUrlNew,
}
